import * as React from 'react';
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { traducirButton } from '../../blocks/traductor';

interface IProps {
    nextStep: () => void
    label?: string
    disabled?: boolean
}

const NextButton = ({nextStep, label = traducirButton(15), disabled = false}: IProps) => {
    return (<>
        <Box display="flex" justifyContent="flex-end" mt={2}>
            <Box>
                <Button variant="contained" color="primary" disabled={disabled} onClick={() => nextStep()}>
                    {label}
                </Button>
            </Box>
        </Box>
    </>)
};

export default NextButton;
